import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Bookmark, BookmarkX } from "lucide-react";
import { toast } from "sonner";
import api from "../api";
import VacancyCard from "../components/VacancyCard";

export default function MijnOpgeslagen() {
  const [saved, setSaved] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/saved-vacancies");
      setSaved(data);
    } catch {
      setSaved([]);
    }
  };
  useEffect(() => { load(); }, []);

  const unsave = async (vid) => {
    try {
      await api.delete(`/saved-vacancies/${vid}`);
      toast.success("Verwijderd uit opgeslagen");
      load();
    } catch (_) { /* ignore */ }
  };

  if (saved === null) return <div className="ok-container py-20 text-sm">Laden...</div>;

  return (
    <section className="ok-section">
      <div className="ok-container">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-[#4a5d5e] hover:text-[#01696f]" data-testid="back-home">
          <ArrowLeft size={14} /> Terug naar home
        </Link>
        <div className="mt-6 flex items-start justify-between gap-4">
          <div>
            <div className="ok-eyebrow mb-2 flex items-center gap-2"><Bookmark size={14} /> Bewaard</div>
            <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">
              Mijn opgeslagen vacatures
            </h1>
            <p className="text-[#4a5d5e] mt-3 max-w-2xl">
              Vacatures die je hebt opgeslagen om later terug te lezen of op te reageren.
            </p>
          </div>
        </div>

        <div className="mt-12">
          {saved.length === 0 ? (
            <div className="border border-dashed border-[#e2e8f0] p-12 text-center" data-testid="no-saved">
              <p className="text-[#4a5d5e]">Je hebt nog geen vacatures opgeslagen.</p>
              <Link
                to="/vacatures"
                className="inline-flex items-center gap-2 mt-6 bg-[#01696f] text-white px-6 py-3 rounded-sm hover:bg-[#015257] font-medium"
              >
                Bekijk open vacatures
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {saved.map((v) => (
                <div key={v.id} className="relative group">
                  <VacancyCard v={v} />
                  <button
                    data-testid={`unsave-${v.id}`}
                    onClick={() => unsave(v.id)}
                    title="Uit opgeslagen verwijderen"
                    className="absolute top-3 right-3 p-2 bg-white/90 border border-[#e2e8f0] hover:bg-[#d32f2f] hover:text-white hover:border-[#d32f2f] transition-colors rounded-sm opacity-0 group-hover:opacity-100"
                  >
                    <BookmarkX size={14} />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
